import React from 'react'

import Image from 'next/image'
import { IoIosClose } from 'react-icons/io'

import { Flex, HStack, IconButton } from '@chakra-ui/react'

import { FileThumbnail } from '@/components/ui'

interface SelectedFilesPreviewIProps {
  removeFile: (file: File) => void
  selectedFiles: File[]
}

interface FileThumbnailWrapperIProps {
  file: File
  removeFile: (file: File) => void
}

const ImageThumbnail = ({ imgUrl }: { imgUrl: string }) => {
  return (
    <Image
      alt='Image'
      className='rounded-md'
      height={50}
      src={imgUrl}
      style={{
        maxWidth: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
      width={50}
    />
  )
}

const FileThumbnailWrapper = ({
  file,
  removeFile,
}: FileThumbnailWrapperIProps) => {
  const isImage = file.type.startsWith('image/')

  const handleRemoveFile = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation()
    removeFile(file)
  }

  return (
    <Flex
      alignItems='center'
      height='12'
      justifyContent='center'
      mt='2'
      position='relative'
    >
      <IconButton
        aria-label='Remove'
        backgroundColor='gray.200'
        onClick={handleRemoveFile}
        position='absolute'
        right='-2.5'
        rounded='full'
        size='2xs'
        top='-2.5'
        zIndex={1}
      >
        <IoIosClose size={20} />
      </IconButton>
      {isImage ? (
        <ImageThumbnail imgUrl={URL.createObjectURL(file)} />
      ) : (
        <FileThumbnail name={file.name} width={137} />
      )}
    </Flex>
  )
}

export const SelectedFilesPreview = ({
  removeFile,
  selectedFiles,
}: SelectedFilesPreviewIProps) => {
  return (
    <HStack
      data-testid='createIncidentModal_selectedFilesPreview'
      gap={3}
      mt={3}
    >
      {selectedFiles.map((file: File) => (
        <Flex
          alignContent='center'
          flexDirection='column'
          key={file.name}
          position='relative'
        >
          <FileThumbnailWrapper file={file} removeFile={removeFile} />
        </Flex>
      ))}
    </HStack>
  )
}
